import { createTheme } from "@mui/material/styles";
import "./styles/App.css";
import "./styles/variables.css";

export const cssVar = (name: string) =>
  getComputedStyle(document.documentElement).getPropertyValue(name).trim();

const primaryTheme = createTheme({
  cssVariables: true,
  palette: {
    background: { default: cssVar("--color-white") },
    text: {
      primary: cssVar("--color-black"),
      secondary: cssVar("--color-black"),
      disabled: cssVar("--color-disabled"),
    },
    primary: {
      main: cssVar("--color-primary-main"),
      light: cssVar("--color-primary-light"),
      dark: cssVar("--color-primary-dark"),
    },
    secondary: {
      main: cssVar("--color-secondary-main"),
      light: cssVar("--color-secondary-light"),
      dark: cssVar("--color-secondary-dark"),
      contrastText: cssVar("--color-secondary-contrastText"),
    },
    error: {
      main: cssVar("--color-error-main"),
      light: cssVar("--color-error-light"),
      dark: cssVar("--color-error-dark"),
    },
    warning: {
      main: cssVar("--color-warning-main"),
      light: cssVar("--color-error-light"),
      dark: cssVar("--color-warning-dark"),
    },
    info: {
      main: cssVar("--color-info-main"),
      light: cssVar("--color-info-light"),
    },
    success: {
      main: cssVar("--color-success-main"),
      light: cssVar("--color-success-light"),
      dark: cssVar("--color-success-dark"),
      contrastText: cssVar("--color-success-contrastText"),
    },
  },
  typography: {
    // fontSize:  16, // Default font size
    fontFamily: "var(--font-family-tertiary)", // Default font family
    h1: {
      fontSize: "3.15rem", //50px
      fontWeight: "var(--font-weight-black)",
    },
    h2: {
      fontSize: "2.25rem", //36px
      fontWeight: "var(--font-weight-bold)",
    },
    h3: {
      fontSize: "1.75rem", //28px
      fontWeight: "var(--font-weight-bold)",
    },
    h4: {
      fontSize: "1.50rem", //24px
      fontWeight: "var(--font-weight-normal)",
    },
    h5: {
      fontSize: "1.25rem", //20px
      fontWeight: "var(--font-weight-medium)",
    },
    h6: {
      fontSize: "1rem", //16px
      fontWeight: "var(--font-weight-bold)",
    },
    caption: {
      fontSize: "1rem", //16px
      fontWeight: "var(--font-weight-normal)",
    },
    body1: {
      fontSize: "0.87rem", //14px
    },
    body2: {
      fontSize: "0.75rem", //12px
    },
    subtitle1: {
      fontSize: "0.65rem", //10px
    },
    subtitle2: {
      fontSize: "0.50rem", //8px
    },
  },
  components: {
    // MuiInputBase: {
    //   defaultProps: {
    //     // Needed to prevent adding a global style for every input field
    //     disableInjectingGlobalStyles: true,
    //   },
    // },
    // MuiCssBaseline: {
    //   styleOverrides: `
    //     @font-face {
    //       font-family: 'Raleway';
    //       font-style: normal;
    //       font-display: swap;
    //       font-weight: 400;
    //       src: local('Raleway'), local('Raleway-Regular'), url(${RalewayWoff2}) format('woff2');
    //       unicodeRange: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF;
    //     }
    //   `,
    // },
    // MuiButton: {
    //   styleOverrides: {
    //     root: {
    //       variants: [
    //         {
    //           props: { variant: "contained", size: "large" },
    //           style: ({ theme }) => ({
    //             margin: "0px",
    //             cornerRadius: cssVar("--border-radius-md"), // Customize border radius
    //             textTransform: "none", // Avoid uppercase transformation of button text
    //             backgroundColor: `${theme.palette.primary.main}`, // Custom background color
    //             color: `${theme.palette.text.secondary}`,
    //             "&:hover": {
    //               backgroundColor: `${theme.palette.primary.main}`, // Custom hover background color
    //             },
    //             "&:disabled": {
    //               backgroundColor: `${theme.palette.primary.dark}`, // Disabled button background color
    //               color: "var(--color-disabled)", // Disabled button text color
    //             },
    //           }),
    //         },
    //         {
    //           props: { variant: "outlined" },
    //           style: ({ theme }) => ({
    //             textTransform: "none",
    //             padding: "4px 10px",
    //           }),
    //         },
    //         {
    //           props: { variant: "text" },
    //           style: ({ theme }) => ({
    //             textTransform: "none",
    //             color: "var(--color-secondary-contrastText)",
    //           }),
    //         },
    //       ],
    //     },
    //   },
    // },
    MuiTextField: {
      styleOverrides: {
        root: {
          variants: [
            {
              props: { variant: "outlined" },
              style: ({ theme }) => ({
                "& .MuiOutlinedInput-root": {
                  // font: "normal 1rem Lato", //disabled due to Extra space between the input label in shrink mode and border
                  borderRadius: "4px",
                  margin: "0px 0px",
                  padding: "0px 0px",
                  borderColor: "var(--color-default)",
                  // color: "var(--control-input-default)",
                  "&.Mui-focused fieldset": {
                    borderColor: "var(--color-black)",
                    borderWidth: "1px",
                  },
                  "&:hover fieldset": {
                    //borderColor: "var(--color-default)",
                    //borderWidth: "1px",
                  },
                },
                "& .MuiInputLabel-outlined": {
                  color: "var(--color-secondary-contrastText)",
                },
                "& .MuiInputLabel-shrink": {
                  color: "var(--color-black)",
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "var(--color-black)",
                },
                "& .MuiIconButton-edgeEnd": {
                  marginRight: "10px",
                },
                "& .Mui-error": {
                  color: "var(--color-error-main)",
                  "&.Mui-focused fieldset": {
                    borderColor: "var( --color-error-main)",
                  },
                  "&:hover fieldset": {
                    borderColor: "var( --color-error-main)",
                  },
                },
                "& textarea": {
                  margin: "10px",
                },
                "& .MuiFormHelperText-root.Mui-error": {
                  fontSize: "0.875rem", //14px
                },
              }),
            },
          ],
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: "0.875rem", // 14px
        },
      },
    },
    // MuiSelect: {
    //   styleOverrides: {
    //     select: () => ({
    //       padding: "10px",
    //     }),
    //   },
    // },
  },
});

export default primaryTheme;
